module.exports = __webpack_public_path__ + "assets/img/食品经营许可证@2x.4d051dbf.png";